import { Point } from "@project/floorplanner/konva/geometry-konva";

export function getAirPathBoundsPoints(
  shaftStart: Point,
  shaftEnd: Point,
  headLength: number,
  headWidth: number,
  showHead: boolean,
  strokeWidth: number,
  strokeJoinLimit: number,
) {
  const shaftHorizontalSpan = shaftEnd.x - shaftStart.x;
  const shaftVerticalSpan = shaftEnd.y - shaftStart.y;
  const shaftLength = Math.hypot(shaftHorizontalSpan, shaftVerticalSpan);

  if (shaftLength === 0) {
    return { points: [], halfStroke: strokeWidth / 2 };
  }

  const { pathDirection, headSide } = getShaftVectors(shaftHorizontalSpan, shaftVerticalSpan, shaftLength);
  const halfHeadWidth = headWidth / 2;
  const halfStroke = strokeWidth / 2;
  const boundsPoints = [shaftStart, shaftEnd];

  if (showHead) {
    const baseCenter = { x: shaftEnd.x - pathDirection.x * headLength, y: shaftEnd.y - pathDirection.y * headLength };
    boundsPoints.push(
      { x: baseCenter.x + headSide.x * halfHeadWidth, y: baseCenter.y + headSide.y * halfHeadWidth },
      { x: baseCenter.x - headSide.x * halfHeadWidth, y: baseCenter.y - headSide.y * halfHeadWidth },
    );
  }

  const tipOverhang = getAirPathTipOverhang(headLength, headWidth, halfStroke, strokeJoinLimit);
  if (tipOverhang > 0 && showHead) {
    boundsPoints.push({
      x: shaftEnd.x + pathDirection.x * tipOverhang,
      y: shaftEnd.y + pathDirection.y * tipOverhang,
    });
  }

  return { points: boundsPoints, halfStroke };
}

export function getAirPathTipOverhang(headLength: number, headWidth: number, halfStroke: number, strokeJoinLimit: number) {
  if (headLength <= 0 || headWidth <= 0 || halfStroke <= 0) {
    return 0;
  }

  const angle = 2 * Math.atan(headWidth / 2 / headLength);
  const sinHalf = Math.sin(angle / 2);

  if (sinHalf <= 0) {
    return 0;
  }

  const joinOverhang = halfStroke / sinHalf;
  const maxJoinOverhang = strokeJoinLimit * halfStroke;
  return Math.max(0, Math.min(joinOverhang, maxJoinOverhang) - halfStroke);
}

function getShaftVectors(shaftHorizontalSpan: number, shaftVerticalSpan: number, shaftLength: number) {
  const pathDirection = { x: shaftHorizontalSpan / shaftLength, y: shaftVerticalSpan / shaftLength };
  const headSide = { x: -pathDirection.y, y: pathDirection.x };
  return { pathDirection, headSide };
}
